import HttpService from "../http/http.service";
import { ProviderMinimalInfo } from "../../models/entities/provider.model";
import { ParticipantProfile } from "../../models/entities/participant.model";
import {
	BiometricsEmailRequest,
	BiometricsRequest,
} from "../../models/endpoints/biometrics-endpoint.model";
import { Biometric } from "../../models/entities/biometrics.model";
import { Engagement } from "../../models/entities/engagements.model";
import { EngagementsRequest } from "../../models/endpoints/engagements-endpoint.model";

const httpService = new HttpService(process.env.REACT_APP_API_DATA_RETRIEVER!);

// Data retriver endpoints
export const DataRetrieverEndpointsService = {
	/* Providers */

	getProviders: async (): Promise<ProviderMinimalInfo[]> => httpService.get("/api/providers/"),

	/* Participants */

	getParticipantInfo: async (): Promise<ParticipantProfile> =>
		httpService.get("/api/patients/info"),

	/* Biometrics */

	getAllBiometrics: async (request: BiometricsRequest): Promise<Biometric[]> =>
		httpService.get(`/api/biometrics/`, request),

	createBiometricEmailReport: async (request: BiometricsEmailRequest): Promise<boolean> =>
		httpService.post(`/api/biometrics/${request.participantId}/report/email`, request),

	createBiometricPreview: async (request: BiometricsEmailRequest): Promise<Blob> =>
		httpService.post(`/api/biometrics/${request.participantId}/report`, request),

	/* Engagements */

	getEngagements: async (request: EngagementsRequest): Promise<Engagement[]> =>
		httpService.get(`/api/engagements/`, request),
};
